import { render, staticRenderFns } from "./SectionTemplate.vue?vue&type=template&id=0b4e378b&scoped=true&"
import script from "./SectionTemplate.vue?vue&type=script&lang=js&"
export * from "./SectionTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SectionTemplate.vue?vue&type=style&index=0&id=0b4e378b&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4e378b",
  null
  
)

export default component.exports